import {Exercise, MssHyroxMainPart, MssHyroxZone, MssPreviewSlideData, MssStations, WorkoutTimeFrame} from "@/types/workouts";

class MssHyroxWorkoutService
{

  getMssHyroxWorkoutPreviewSlides(workout: MssHyroxMainPart): MssPreviewSlideData[]
  {
    const previewSlides: MssPreviewSlideData[] = [];

    workout.zones.forEach((zone: MssHyroxZone) =>
    {
      const stations: Exercise[] = [];
      zone.stations.forEach((station: MssStations) =>
      {
        station.exercises.forEach((exersice: Exercise) =>
        {
          stations.push({
            ...exersice,
            station_position: station.position,
            station: station.name
          });
        });
      });
      previewSlides.push({
        name: zone.name,
        type: zone.type,
        position: zone.position,
        duration: workout.duration,
        exercises: stations,
        zoneName: zone.name,
        zone: zone.position,

      });
    });

    return previewSlides;
  }


  parseTimeFrames(workout: MssHyroxMainPart)
  {
    const timeFrameArray: WorkoutTimeFrame[] = [];

    timeFrameArray.push({
      duration: workout.duration,
      roundIdx: 0,
      workInterval: true
    });

    if (workout.prep_time) {
      timeFrameArray.unshift({duration: workout.prep_time, restInterval: true});
    } else {
      timeFrameArray.unshift({duration: 5, restInterval: true});
    }

    return timeFrameArray;
  }

  parseCircuitTimeframes(mainPart: MssHyroxMainPart)
  {
    const timeFrames: WorkoutTimeFrame[] = [];
    const {rounds, workInterval, restInterval} = mainPart.zones[0] as MssHyroxZone;
    (new Array(rounds)).fill(0).forEach((value, roundIdx) =>
    {
      timeFrames.push({workInterval: true, roundIdx, duration: workInterval as number});
      timeFrames.push({restInterval: true, roundIdx, duration: restInterval as number});
    });

    if (mainPart.prep_time) {
      timeFrames.unshift({duration: mainPart.prep_time, roundIdx: 0, restInterval: true});
    } else {
      timeFrames.unshift({duration: 5, roundIdx: 0, restInterval: true});
    }
    return timeFrames;
  }
}

export const mssHyroxWorkoutService = new MssHyroxWorkoutService();